import { render, staticRenderFns } from "./extendPeriod.vue?vue&type=template&id=22a3765c&scoped=true&"
import script from "./extendPeriod.vue?vue&type=script&lang=js&"
export * from "./extendPeriod.vue?vue&type=script&lang=js&"
import style0 from "./extendPeriod.vue?vue&type=style&index=0&id=22a3765c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a3765c",
  null
  
)

export default component.exports